import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";

function ConfirmDelete(props) {
  const {
    show = false,
    label = "Are You Sure You Want to Delete?",
    proceed = () => {},
    cancel = () => {},
    actionBtnLabel = "Delete"
  } = props;

  return (
    <Modal isOpen={show} className="modal-success">
      <ModalBody>
        <h4 className="text-center mb-4">{label}</h4>
      </ModalBody>
      <ModalFooter style={{ justifyContent: "space-around" }}>
        <Button color="secondary" size="md" onClick={cancel}>
          Cancel
        </Button>
        <Button color="primary" className="promote" size="md" onClick={proceed}>
          {actionBtnLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmDelete;

/**
 * Show a message if it fails to delete
 * @param show: boolean
 * @param label: string
 * @param onClose: function
 */
export function FailedToDelete(props) {
  const {
    show = false,
    label = "Failed to Delete",
    onClose = () => {}
  } = props;

  return (
    <Modal isOpen={show} className="modal-success">
      <ModalBody>
        <i className="bi bi-exclamation-octagon cant-delete" />
        <h4 className="text-center mb-4 mt-5">{label}</h4>
      </ModalBody>
      <ModalFooter style={{ justifyContent: "space-around" }}>
        <Button color="primary" className="promote" size="md" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}
